import React, { useState } from "react";
import * as IoIcons from "react-icons/io";
import { MDBCollapse, MDBBtn } from "mdb-react-ui-kit";
import InfoFechaSolicitud from "./Funciones/InfoFechas";
import InfoEstandares from "./Funciones/InfoEstandares";
import InfoSistemaCalidad from "./Funciones/InfoSistemaCalidad";
import InfoDeclaracion from "./Funciones/InfoDeclaracionCompromiso";
import { useParams } from "react-router-dom";
import InfoControlLegal from "./Funciones/InfoControlLegal";
import InfoLiderSolicitud from "./Funciones/InfoLiderSolicitud";
import Consolidado from "./Consolidado";
import Cookies from "universal-cookie";
import TablaDeclaracion from "./Funciones/TablaDeclaracion";
import CertificacionesSolicitud from "./Funciones/CertificacionesSolicitud";
function ProcesoSolicitud(props) {
  const cookie = new Cookies();
  let params = useParams();
  let { id } = useParams();
  let { idInstitucion } = useParams();
  console.log(id);
  const [showShow, setShowShow] = useState(false);
  const [showShow1, setShowShow1] = useState(false);
  const [showShow2, setShowShow2] = useState(false);
  const [showShow8, setShowShow8] = useState(false);
  const [showShow9, setShowShow9] = useState(false);
  const [showShow10, setShowShow10] = useState(false);
  const toggleShow = () => setShowShow(!showShow);
  const toggleShow1 = () => setShowShow1(!showShow1);
  const toggleShow2 = () => setShowShow2(!showShow2);
  const toggleShow8 = () => setShowShow8(!showShow8);
  const toggleShow9 = () => setShowShow9(!showShow9);
  const toggleShow10 = () => setShowShow10(!showShow10);
  const [showShow11, setShowShow11] = useState(false);
  const toggleShow11 = () => setShowShow11(!showShow11);
  return (
    <>
      <div className="test">
        <div>
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Proceso De Solicitud
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive"></div>

                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <Consolidado idInstitucion={params.idInstitucion} />

                    <hr />
                    <tr>
                      {" "}
                      <MDBBtn
                        outline
                        className="btn btn-light btn-user btn-block"
                        onClick={toggleShow}
                      >
                        <IoIcons.IoIosPaper />{" "}
                        <left>
                          Información del líder designado por la institución
                          para la Acreditación en Salud
                        </left>
                      </MDBBtn>
                      <MDBCollapse show={showShow}>
                        <InfoLiderSolicitud idSolicitud={id} />
                      </MDBCollapse>
                    </tr>
                    <hr className="sidebar-divider" />

                    <tr>
                      {" "}
                      <MDBBtn
                        outline
                        className="btn btn-light btn-user btn-block"
                        onClick={toggleShow1}
                      >
                        <IoIcons.IoIosCalendar />
                        Fecha propuesta de visita
                      </MDBBtn>
                      <MDBCollapse show={showShow1}>
                        <InfoFechaSolicitud idSolicitud={id} />
                      </MDBCollapse>
                    </tr>
                    <hr className="sidebar-divider" />
                    <tr>
                      <MDBBtn
                        outline
                        className="btn btn-light btn-user btn-block"
                        onClick={toggleShow8}
                      >
                        <IoIcons.IoIosDesktop />
                        Sistema de calidad
                      </MDBBtn>
                      <MDBCollapse show={showShow8}>
                        <InfoSistemaCalidad idSolicitud={id} />
                      </MDBCollapse>
                    </tr>
                    <hr className="sidebar-divider" />
                    <tr>
                      <MDBBtn
                        outline
                        className="btn btn-light btn-user btn-block"
                        onClick={toggleShow9}
                      >
                        <IoIcons.IoIosText />
                        Aspectos de control Legal
                      </MDBBtn>

                      <MDBCollapse show={showShow9}>
                        <InfoControlLegal idSolicitud={id} />
                      </MDBCollapse>
                    </tr>
                    <hr className="sidebar-divider" />
                    <tr>
                      <MDBBtn
                        outline
                        className="btn btn-light btn-user btn-block"
                        onClick={toggleShow10}
                      >
                        <IoIcons.IoIosPersonAdd /> Declaración de compromiso por
                        parte del representante legal
                      </MDBBtn>

                      <MDBCollapse show={showShow10}>
                        <TablaDeclaracion idSolicitud={id} />
                      </MDBCollapse>
                    </tr>
                    <hr />
                    <tr>
                      {" "}
                      <MDBBtn
                        outline
                        className="btn btn-light btn-user btn-block"
                        onClick={toggleShow11}
                      >
                        <IoIcons.IoIosPaper />{" "}
                        <left>RELACION CERTIFICACIONES</left>
                      </MDBBtn>
                      <MDBCollapse show={showShow11}>
                        <CertificacionesSolicitud idSolicitud={id} />
                      </MDBCollapse>
                    </tr>
                    <hr />
                    <hr className="sidebar-divider" />
                    <tr>
                      <MDBBtn
                        outline
                        className="btn btn-light btn-user btn-block"
                        onClick={toggleShow2}
                      >
                        <IoIcons.IoIosAddCircle /> calificación de estandares
                      </MDBBtn>

                      <MDBCollapse show={showShow2}>
                        <InfoEstandares
                          idSolicitud={id}
                          idInstitucion={idInstitucion}
                        />
                      </MDBCollapse>
                    </tr>
                    <hr />
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ProcesoSolicitud;
